import { Banknote, Clock, Wrench, Trophy, Lock } from 'lucide-react';

// Hourly slots from 08:00 to 23:00 (matches the customer flow).
export const TIME_SLOTS = Array.from({ length: 16 }, (_, i) => {
  const start = `${String(8 + i).padStart(2, '0')}:00`;
  const end = `${String(8 + i + 1).padStart(2, '0')}:00`;
  return `${start}-${end === '24:00' ? '00:00' : end}`;
});

export const DURATIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];

export const PAYMENT_METHODS = [
  { value: 'cash', label: 'Cash', icon: Banknote },
  { value: 'bank_transfer', label: 'Bank Transfer', icon: Banknote },
  { value: 'complimentary', label: 'Complimentary', icon: Banknote },
  { value: 'pay_later', label: 'Pay Later (Hold)', icon: Clock },
];

export const BLOCK_LABELS = [
  { value: 'MAINTENANCE', label: 'Maintenance', icon: Wrench },
  { value: 'TOURNAMENT', label: 'Tournament', icon: Trophy },
  { value: 'PRIVATE_EVENT', label: 'Private Event', icon: Lock },
  { value: 'OTHER', label: 'Other', icon: Lock },
];
